import { useAllActionRequired } from '@/hooks/queries/useAllActionRequired';

const useHasActionsRequired = () => {
	const { data: allActionRequired } = useAllActionRequired();

	return {
		hasActionsRequired:
			allActionRequired?.data && allActionRequired?.data?.length > 0,
	};
};

export default useHasActionsRequired;
